export default __webpack_public_path__ + "static/media/uBudget-ss.18b59429.png";